
import React, { useState, useEffect } from 'react';
import {
  VStack, Input, Select, Textarea, Text, Box, Button,
  useToast, SimpleGrid, InputGroup, InputRightElement
} from '@chakra-ui/react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import SelectorPerfilUsuario from 'components/PerfilUsuario/SelectorPerfilUsuario';
import { GOOGLE_MAPS_API_KEY } from 'config/googleMaps';

type Modo = 'new' | 'edit' | 'view';

interface Props {
  modo: Modo;
  data?: any;
  onSubmit?: (data: any) => void;
}

const tarifas = {
  Espectacular: 300,
  Luminoso: 200,
};

const SolicitudAnuncio: React.FC<Props> = ({ modo, data, onSubmit }) => {
  const toast = useToast();
  const [perfilSeleccionado, setPerfilSeleccionado] = useState<any>(null);

  const [tipo, setTipo] = useState(data?.tipo || '');
  const [ancho, setAncho] = useState(data?.ancho || '');
  const [alto, setAlto] = useState(data?.alto || '');
  const [superficie, setSuperficie] = useState(0);
  const [costo, setCosto] = useState(data?.costo || 0);
  const [direccion, setDireccion] = useState(data?.direccion || '');
  // const [coordenadas, setCoordenadas] = useState( {lat: Number(data?.lat), lng: Number( data?.lng) });

  
  const [coordenadas, setCoordenadas] = useState({
    lat: Number(data?.lat) || 19.4326,
    lng: Number(data?.lng) || -99.1332,
  });
    const [responsable, setResponsable] = useState(data?.responsable || '');
  const [observaciones, setObservaciones] = useState(data?.observaciones || '');

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  useEffect(() => {
    const area = ancho * alto;
    setSuperficie(area);
    if (tipo && area) {
      const tarifa = tarifas[tipo as keyof typeof tarifas] || 0;
      setCosto(area * tarifa);
    }
  }, [tipo, ancho, alto]);

  const buscarDireccion = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: direccion }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        setCoordenadas({ lat: loc.lat(), lng: loc.lng() });
        setDireccion(results[0].formatted_address);
      } else {
        toast({
          title: 'Dirección no encontrada',
          description: 'Especifica una dirección más precisa.',
          status: 'error',
        });
      }
    });
  };

  const handlePerfil = (perfil: any) => {
    setPerfilSeleccionado(perfil);
  };
  
  const handleGuardar = async () => {
    if (!tipo || !ancho || !alto || !direccion || !responsable) {
      toast({
        title: 'Campos obligatorios',
        description: 'Revisa que todos los campos estén completos.',
        status: 'warning',
      });
      return;
    }
  
    const payload = {
      tipo,
      ancho,
      alto,
      superficie,
      costo,
      direccion,
      lat: coordenadas.lat,
      lng: coordenadas.lng,
      responsable,
      observaciones,
      //fecha: new Date(),
    };
  
    try {
      const method = modo === 'edit' ? 'PUT' : 'POST';
      const endpoint =
        modo === 'edit'
          ? `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-anuncio/${data.id}`
          : `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-anuncio`
  
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
  
      if (!response.ok) {
        throw new Error(result.message || 'Error al guardar');
      }
  
      toast({
        title: 'Solicitud guardada',
        description: modo === 'edit' ? 'Se actualizó exitosamente.' : 'Se registró exitosamente.',
        status: 'success',
      });
  
      onSubmit?.(result);
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.message || 'Error al guardar solicitud.',
        status: 'error',
      });
    }
  };
  
  
  if (!isLoaded) return <Text>Cargando mapa...</Text>;

  return (
    <VStack spacing={4} align="stretch">
      {(modo === 'edit' || modo === 'new') ? (
        <>
      <SelectorPerfilUsuario onPerfilSeleccionado={handlePerfil} />

                <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={4}>
        
          <Select placeholder="Tipo de anuncio" value={tipo} onChange={(e) => setTipo(e.target.value)}>
            {Object.keys(tarifas).map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </Select>

          <Input type="number" placeholder="Ancho (m)" value={ancho} onChange={(e) => setAncho(Number(e.target.value))} />
          <Input type="number" placeholder="Alto (m)" value={alto} onChange={(e) => setAlto(Number(e.target.value))} />
</SimpleGrid>
          <Text><strong>Superficie:</strong> {superficie.toFixed(2)} m²</Text>
          <Text><strong>Costo estimado:</strong> ${costo.toFixed(2)}</Text>

          <InputGroup>
            <Input
              placeholder="Dirección"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
            />
            <InputRightElement width="4.5rem">
              <Button h="1.75rem" size="sm" onClick={buscarDireccion}>
                Buscar
              </Button>
            </InputRightElement>
          </InputGroup>

          <Box h="200px" w="100%">
            <GoogleMap
              zoom={15}
              center={coordenadas}
              mapContainerStyle={{ width: '100%', height: '100%' }}
            >
              <Marker
                position={coordenadas}
                draggable
                onDragEnd={(e) =>
                  setCoordenadas({
                    lat: e.latLng?.lat() || coordenadas.lat,
                    lng: e.latLng?.lng() || coordenadas.lng,
                  })
                }
              />
            </GoogleMap>
          </Box>

          <Input
            placeholder="Responsable del anuncio"
            value={responsable}
            onChange={(e) => setResponsable(e.target.value)}
          />

          <Textarea
            placeholder="Observaciones"
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />

          <Button colorScheme="green" onClick={handleGuardar}>
            {modo === 'new' ? 'Guardar solicitud' : 'Actualizar'}
          </Button>
        </>
      ) : (
        <>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <Box>
              <Text><strong>Tipo de anuncio:</strong> {tipo}</Text>
              <Text><strong>Dimensiones:</strong> {ancho} m x {alto} m</Text>
              <Text><strong>Superficie:</strong> {superficie.toFixed(2)} m²</Text>
              <Text><strong>Costo:</strong> ${costo.toFixed(2)}</Text>
            </Box>
            <Box>
              <Text><strong>Dirección:</strong> {direccion}</Text>
              <Text><strong>Responsable:</strong> {responsable}</Text>
              {observaciones && <Text><strong>Observaciones:</strong> {observaciones}</Text>}
            </Box>
          </SimpleGrid>

          <Box h="200px" w="100%">
            <GoogleMap
              zoom={15}
              center={coordenadas}
              mapContainerStyle={{ width: '100%', height: '100%' }}
            >
              <Marker position={coordenadas} />
            </GoogleMap>
          </Box>
        </>
      )}
    </VStack>
  );
};

export default SolicitudAnuncio;
